// Per-city configuration. The active city is selected in environment*.ts.
// De-hardcodes the map center / data source that used to be inlined in code.
// NOTE: native apps will eventually resolve the city at runtime (geolocation +
// cities.json — see ~/Desktop/multi-city-deployment.md Step 6); this build-time
// default is the interim mechanism.

export type DataSource = 'gtfs' | 'lines';

export interface CityConfig {
  id: string;
  name: string;
  center: [number, number]; // [lat, lng]
  zoom: number;
  dataSource: DataSource;    // 'gtfs' = external feed, 'lines' = imported Line records
}

export const CITIES: Record<string, CityConfig> = {
  cochabamba: { id: 'cochabamba', name: 'Cochabamba', center: [-17.3895, -66.1568], zoom: 13, dataSource: 'gtfs' },
  lapaz:      { id: 'lapaz',      name: 'La Paz',     center: [-16.4955, -68.1336], zoom: 13, dataSource: 'lines' },
};

export const CITY_HOSTNAME_ALIASES: Record<string, string> = {
  cbba: 'cochabamba',
  lpz:  'lapaz',
};
